import { useGlobalContext } from "@aleksundshantu/aunds-utils-react/contexts";
import { optimizeURL } from "@/utils/url";
import { CustomLink } from "../CustomLink";
import { CustomSVG } from "../_primitives/CustomSVG/CustomSVG";

interface TranscriptButtonProps {
  href: string;
  ariaLabel: string;
  className?: string;
}

export const TranscriptButton = ({
  href,
  ariaLabel,
  className = "",
}: TranscriptButtonProps) => {
  const { getIcon } = useGlobalContext();

  return (
    <CustomLink
      className={className}
      href={optimizeURL(href)}
      target="_blank"
      aria-label={ariaLabel}
    >
      <CustomSVG
        width={32}
        height={32}
        src={getIcon("video-controls-transcript")}
        wrapper="span"
        aria-hidden="true"
        className="vds-icon is-flex"
      />
    </CustomLink>
  );
};
